import {
  RegistrationFlowConfiguration,
  useRegistrationFlowConfiguration,
} from './useRegistrationFlowConfiguration';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { registrationFlowOrchestrationSelector } from '../redux/reducers/registrationFlowOrchestrationReducer';
import { RegistrationFlowOrchestration } from '../types/apiConfig';

export function useRegistrationFlowOrchestration(): RegistrationFlowOrchestration {
  const registrationFlowOrchestrations = useSelector(registrationFlowOrchestrationSelector);
  const registrationFlowConfiguration = useRegistrationFlowConfiguration();
  return useMemo(() => {
    const identityLevel = (registrationFlowConfiguration as RegistrationFlowConfiguration)
      .identityLevel;
    const orch = registrationFlowOrchestrations.find((o) => o.identityLevel === identityLevel);
    return orch!;
  }, [registrationFlowConfiguration, registrationFlowOrchestrations]);
}
